import { isDingdingMiniapp } from "../_utils/miniappEnvApp";
import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var previewImage = normalize.previewImage(function (args) {
  return isDingdingMiniapp ? dd.previewImage(args) : my.previewImage(args);
}, CONTAINER_NAME.ALIPAY);
export default previewImage;